import React from 'react';
import './timeline-divider.css';

export default function TimelineDivider({ showLine = true }) {
    return (
        <div className="timeline-divider" aria-hidden="true">
            <span className="timeline-divider__symbol">✽</span>
            {showLine ? <div className="timeline-divider__line" /> : null}
        </div>
    );
}
